import { render, staticRenderFns } from "./profile_reviews.page.vue?vue&type=template&id=6d9d0ee4&scoped=true&"
import script from "./profile_reviews.page.vue?vue&type=script&lang=js&"
export * from "./profile_reviews.page.vue?vue&type=script&lang=js&"
import style0 from "./profile_reviews.page.vue?vue&type=style&index=0&id=6d9d0ee4&scoped=true&lang=scss&"
import style1 from "./profile_reviews.page.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9d0ee4",
  null
  
)

export default component.exports